<template>
  <vnLogin :reset="reset" :isSilent="isSilent" :success="success" :error="error" :closeLogin="closeLogin"></vnLogin>
</template>

<script>
import vnLogin from '../VnLogin/index.vue'
export default {
  props: {
    reset:Boolean,
    isProtocol: {
      type: Boolean,
      default: true,
    },
    isSilent: {
      type: Boolean,
      default: false,
    },
    success: {
      typeof:Function,
      default:function(){
        return ()=>{}
      }
    },
    error: {
      typeof:Function,
      default:function(){
        return ()=>{}
      }
    },
    closeLogin: {
      typeof: Function,
      default:function(){
        return ()=>{}
      }
    }
  },
  components:{
     vnLogin : vnLogin
  }
}
</script>